module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.hasErrors
    }
  }, [(!['header', 'row', 'shared-form-preview', 'text-entry'].includes(_vm.field.type)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.field.name
    }
  }, [(_vm.required) ? _c('span', [_vm._v("* ")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.field.description) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.fieldComponent) ? _c(_vm.fieldComponent, _vm._g(_vm._b({
    ref: "inputRef",
    tag: "component",
    attrs: {
      "field": _vm.field,
      "required": _vm.required,
      "value": _vm.value,
      "locked": _vm.field.readOnly || _vm.locked
    },
    on: {
      "validate": _vm.validate
    }
  }, 'component', _vm.$attrs, false), _vm.$listeners)) : _vm._e(), _vm._v(" "), (_vm.hasErrors) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n    " + _vm._s(_vm.errorList[0].msg) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef68fe36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/FieldRenderWrapper.vue
// module id = 1752
// module chunks = 1